import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, FaTiktok, FaMediumM } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { MdMailOutline } from 'react-icons/md';
import { PRODUCT_URLS } from '@podus/utils';
import podusLogoFull from './assets/logo.svg';

const footerLinks: { title: string; links: { label: string; href: string; active?: boolean }[] }[] = [
    {
        title: 'Company',
        links: [
            { label: 'Service Coverage', href: `${PRODUCT_URLS.podushelp}/service-coverage` },
            { label: 'Who Podus is for', href: `${PRODUCT_URLS.podushelp}/who-podus-is-for` },
            { label: 'Features', href: `${PRODUCT_URLS.podushelp}/features` },
        ],
    },
    {
        title: 'Services',
        links: [
            { label: 'Podus Contract', href: PRODUCT_URLS.poduscontract },
            { label: 'Podus Legal Aid', href: PRODUCT_URLS.podusaid },
            { label: 'Podus Legal Appointment', href: PRODUCT_URLS.podusappointment },
            { label: 'Podus Legal Assistant', href: PRODUCT_URLS.chatpodusai },
        ],
    },
    {
        title: 'Resources',
        links: [
            // { label: 'Blog', href: '/blog' },
            { label: 'How it Works', href: `${PRODUCT_URLS.podushelp}/how-it-works` },
            { label: 'Cookie Policy', href: `${PRODUCT_URLS.podushelp}/cookie-policy` },
            { label: 'Privacy Policy', href: `${PRODUCT_URLS.podushelp}/privacy` },
        ],
    },
    {
        title: 'Support',
        links: [
            { label: 'FAQs', href: `${PRODUCT_URLS.podushelp}/faqs` },
            { label: 'Privacy Policy', href: `${PRODUCT_URLS.podushelp}/privacy` },
            { label: 'Terms & Conditions', href: `${PRODUCT_URLS.podushelp}/terms` },
        ],
    },
];

const socials = [
    { icon: FaXTwitter, label: 'X', href: 'https://x.com/citizen_gavel' },
    { icon: FaInstagram, label: 'Instagram', href: 'https://instagram.com/citizens_gavel' },
    { icon: FaFacebookF, label: 'Facebook', href: 'https://facebook.com/CitizenGavel' },
    { icon: FaYoutube, label: 'YouTube', href: 'https://youtube.com/@citizensgavel' },
    { icon: FaLinkedinIn, label: 'LinkedIn', href: 'https://linkedin.com/company/citizengavel' },
    { icon: FaMediumM, label: 'Medium', href: 'https://medium.com/@hello_98724' },
    { icon: FaTiktok, label: 'TikTok', href: 'https://tiktok.com/@citizens_gavel_' },
];

export default function Footer() {
    return (
        <footer className="bg-secondary">
            <div className="m-auto max-w-[1920px] leading-[2.3]">
                {/* ─── Newsletter ─── */}
                <div className="relative overflow-hidden">
                    {/* Subtle grid pattern */}
                    <div
                        className="absolute inset-0 opacity-[0.04]"
                        style={{
                            backgroundImage:
                                'linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)',
                            backgroundSize: '50px 50px',
                        }}
                    />

                    <div className="relative flex flex-col gap-6 px-5 py-10 lg:flex-row lg:items-center lg:justify-between lg:gap-16 lg:px-16 lg:py-14 xl:px-20">
                        <h3 className="text-xl font-bold text-white lg:text-2xl">Subscribe to our newsletter</h3>

                        <div className="w-full text-center lg:max-w-md">
                            <form
                                className="flex items-center overflow-hidden rounded-[10px] border border-white/10 bg-white/10"
                                onSubmit={(e) => e.preventDefault()}
                            >
                                <div className="flex flex-1 items-center gap-2 px-4 lg:px-5">
                                    <MdMailOutline className="h-5 w-5 flex-shrink-0 text-white/40" />
                                    <input
                                        type="email"
                                        placeholder="enter your email"
                                        className="w-full bg-transparent py-3.5 text-sm text-white outline-none placeholder:text-[#EEEBF0]"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    className="bg-primary hover:bg-primary-400 mr-1 flex-shrink-0 rounded-[10px] px-6 py-3 text-sm font-medium text-white transition-all duration-200 hover:scale-[1.03] active:scale-[0.98] lg:px-8"
                                >
                                    Subscribe
                                </button>
                            </form>
                            <p className="mt-2.5 pl-1 text-xs font-medium text-[#797C7F]">
                                You will be able to unsubscribe at any time.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Divider */}
                <div className="mx-5 border-t border-white/10 lg:mx-16 xl:mx-20" />

                {/* ─── Brand Bar ─── */}
                <div className="mb-[10px] border-y border-[#343434] px-3 py-5 lg:px-12 lg:py-6 xl:px-16">
                    {/* Desktop: 3-column layout */}
                    <div className="hidden items-center justify-between lg:flex">
                        {/* Social Icons */}
                        <div className="flex items-center gap-5">
                            {socials.map((s) => (
                                <a
                                    key={s.label}
                                    href={s.href}
                                    className="text-[#A6A6A6] transition-colors hover:text-white"
                                    aria-label={s.label}
                                >
                                    <s.icon className="h-5 w-5" />
                                </a>
                            ))}
                        </div>

                        {/* Logo */}
                        <div className="flex items-center gap-2.5">
                            <img src={podusLogoFull} alt="Podus AI" className="h-7" />
                        </div>

                        {/* Tagline */}
                        <p className="font-bold text-white">Legal Solutions for Every Situation</p>
                    </div>

                    {/* Mobile: centered stack */}
                    <div className="flex flex-col items-center text-center lg:hidden">
                        {/* Logo */}
                        <div className="flex items-center gap-2.5">
                            <img src={podusLogoFull} alt="Podus AI" className="h-7" />
                        </div>
                        <p className="mt-2 text-sm text-white/50">Legal Solutions for Every Situation</p>

                        {/* Social Icons */}
                        <div className="mt-6 flex items-center gap-6">
                            {socials.map((s) => (
                                <a
                                    key={s.label}
                                    href={s.href}
                                    className="text-[#A6A6A6] transition-colors hover:text-white"
                                    aria-label={s.label}
                                >
                                    <s.icon className="h-5 w-5" />
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                {/* ─── Link Columns ─── */}
                <div className="px-5 pb-10 lg:px-16 lg:pb-14 xl:px-20">
                    {/* Desktop: 4-column grid */}
                    <div className="hidden grid-cols-4 gap-8 lg:grid xl:gap-12">
                        {footerLinks.map((group) => (
                            <div key={group.title}>
                                <h4 className="mb-5 text-base font-bold text-white">{group.title}</h4>
                                <ul className="space-y-4">
                                    {group.links.map((link) => (
                                        <li key={link.label}>
                                            <a
                                                href={link.href}
                                                className={`text-sm transition-colors ${
                                                    link.active
                                                        ? 'text-primary hover:text-primary-400'
                                                        : 'text-white/50 hover:text-white/80'
                                                }`}
                                            >
                                                {link.label}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>

                    {/* Mobile: centered stacked groups */}
                    <div className="flex flex-col items-center gap-8 text-center lg:hidden">
                        {footerLinks.map((group) => (
                            <div key={group.title}>
                                <h4 className="mb-4 text-lg font-bold text-white">{group.title}</h4>
                                <ul className="space-y-3">
                                    {group.links.map((link) => (
                                        <li key={link.label}>
                                            <a
                                                href={link.href}
                                                className={`text-sm transition-colors ${
                                                    link.active
                                                        ? 'text-primary hover:text-primary-400'
                                                        : 'text-white/50 hover:text-white/80'
                                                }`}
                                            >
                                                {link.label}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ─── Copyright ─── */}
                <div className="mx-5 border-t border-white/10 lg:mx-16 xl:mx-20" />
                <div className="px-5 py-5 lg:px-16 lg:py-6 xl:px-20">
                    <p className="text-center text-xs text-white/50 lg:text-sm">
                        &copy; 2026 Podus. All Rights Reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
